/* eslint-disable */
import { ProductColorItem_Item, Promotion } from "../../../common/common";

export const protobufPackage = "store.api.misc.favorite";

export interface ListFavoritesResponse {
  /** Order by `published` DESC, `product_id` ASC */
  favorites: Favorite[];
}

export interface AddFavoriteRequest {
  /** Required. */
  productId: string;
}

export interface DeleteFavoriteRequest {
  /** Required. */
  productId: string;
}

export interface Favorite {
  /** Output only. */
  item:
    | ProductColorItem_Item
    | undefined;
  /** Output only. */
  published: boolean;
  /** Output only. Image 360 pixels. */
  image: string;
  /** Output only */
  promotion: Promotion | undefined;
}

export interface MergeFavoritesRequest {
  /** Required. */
  productIds: string[];
}

function createBaseListFavoritesResponse(): ListFavoritesResponse {
  return { favorites: [] };
}

export const ListFavoritesResponse = {
  fromJSON(object: any): ListFavoritesResponse {
    return {
      favorites: Array.isArray(object?.favorites) ? object.favorites.map((e: any) => Favorite.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListFavoritesResponse): unknown {
    const obj: any = {};
    if (message.favorites) {
      obj.favorites = message.favorites.map((e) => e ? Favorite.toJSON(e) : undefined);
    } else {
      obj.favorites = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListFavoritesResponse>, I>>(base?: I): ListFavoritesResponse {
    return ListFavoritesResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListFavoritesResponse>, I>>(object: I): ListFavoritesResponse {
    const message = createBaseListFavoritesResponse();
    message.favorites = object.favorites?.map((e) => Favorite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddFavoriteRequest(): AddFavoriteRequest {
  return { productId: "" };
}

export const AddFavoriteRequest = {
  fromJSON(object: any): AddFavoriteRequest {
    return { productId: isSet(object.productId) ? String(object.productId) : "" };
  },

  toJSON(message: AddFavoriteRequest): unknown {
    const obj: any = {};
    message.productId !== undefined && (obj.productId = message.productId);
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFavoriteRequest>, I>>(base?: I): AddFavoriteRequest {
    return AddFavoriteRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<AddFavoriteRequest>, I>>(object: I): AddFavoriteRequest {
    const message = createBaseAddFavoriteRequest();
    message.productId = object.productId ?? "";
    return message;
  },
};

function createBaseDeleteFavoriteRequest(): DeleteFavoriteRequest {
  return { productId: "" };
}

export const DeleteFavoriteRequest = {
  fromJSON(object: any): DeleteFavoriteRequest {
    return { productId: isSet(object.productId) ? String(object.productId) : "" };
  },

  toJSON(message: DeleteFavoriteRequest): unknown {
    const obj: any = {};
    message.productId !== undefined && (obj.productId = message.productId);
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFavoriteRequest>, I>>(base?: I): DeleteFavoriteRequest {
    return DeleteFavoriteRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<DeleteFavoriteRequest>, I>>(object: I): DeleteFavoriteRequest {
    const message = createBaseDeleteFavoriteRequest();
    message.productId = object.productId ?? "";
    return message;
  },
};

function createBaseFavorite(): Favorite {
  return { item: undefined, published: false, image: "", promotion: undefined };
}

export const Favorite = {
  fromJSON(object: any): Favorite {
    return {
      item: isSet(object.item) ? ProductColorItem_Item.fromJSON(object.item) : undefined,
      published: isSet(object.published) ? Boolean(object.published) : false,
      image: isSet(object.image) ? String(object.image) : "",
      promotion: isSet(object.promotion) ? Promotion.fromJSON(object.promotion) : undefined,
    };
  },

  toJSON(message: Favorite): unknown {
    const obj: any = {};
    message.item !== undefined && (obj.item = message.item ? ProductColorItem_Item.toJSON(message.item) : undefined);
    message.published !== undefined && (obj.published = message.published);
    message.image !== undefined && (obj.image = message.image);
    message.promotion !== undefined &&
      (obj.promotion = message.promotion ? Promotion.toJSON(message.promotion) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<Favorite>, I>>(base?: I): Favorite {
    return Favorite.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Favorite>, I>>(object: I): Favorite {
    const message = createBaseFavorite();
    message.item = (object.item !== undefined && object.item !== null)
      ? ProductColorItem_Item.fromPartial(object.item)
      : undefined;
    message.published = object.published ?? false;
    message.image = object.image ?? "";
    message.promotion = (object.promotion !== undefined && object.promotion !== null)
      ? Promotion.fromPartial(object.promotion)
      : undefined;
    return message;
  },
};

function createBaseMergeFavoritesRequest(): MergeFavoritesRequest {
  return { productIds: [] };
}

export const MergeFavoritesRequest = {
  fromJSON(object: any): MergeFavoritesRequest {
    return { productIds: Array.isArray(object?.productIds) ? object.productIds.map((e: any) => String(e)) : [] };
  },

  toJSON(message: MergeFavoritesRequest): unknown {
    const obj: any = {};
    if (message.productIds) {
      obj.productIds = message.productIds.map((e) => e);
    } else {
      obj.productIds = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MergeFavoritesRequest>, I>>(base?: I): MergeFavoritesRequest {
    return MergeFavoritesRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<MergeFavoritesRequest>, I>>(object: I): MergeFavoritesRequest {
    const message = createBaseMergeFavoritesRequest();
    message.productIds = object.productIds?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
